import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingCardComponent } from './upcoming-card/upcoming-card.component';
import { UpcomingPremiereComponent } from './upcoming-premiere/upcoming-premiere.component';
import { FlexLayoutModule} from '@angular/flex-layout';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    UpcomingCardComponent,
    UpcomingPremiereComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    SharedModule

  ],
  exports:[UpcomingCardComponent]
})
export class UpcomingModule { }
